export const config = {
	base_url: process.env.REACT_APP_BASE_URL || '',
	coingecko_url: process.env.REACT_APP_COINGECKO_URL || '',
	binance_url: process.env.REACT_APP_BINANCE_URL || '',
};
